<template>
  <div>
    <div class="login-content" v-if="isopenid">
      <div class="title">账号绑定</div>
      <div class="form">
        <div class="form-item">
          <div class="form-item-field">
            <label for="">手机号</label>
            <input
              type="tel"
              v-model="phone"
              placeholder="请输入手机号"
              @blur="checkEvtPhone"
            />
          </div>
          <div class="err-msg">{{ errMsgPhone }}</div>
        </div>

        <div
          class="form-item"
          v-if="phoneCode !== 1"
          @click="verificationClick"
        >
          <p class="verification">
            点击<span style="color: blue">获取验证码</span>,验证码3分钟内有效
          </p>
        </div>
        <div class="code-txt" v-if="phoneCode == 1">
          <p class="verification" style="color: blue">{{ bottomnumber }}s</p>
        </div>
        <div class="form-item">
          <div class="form-item-field">
            <label for="">验证码</label>
            <input
              type="text"
              v-model="idCard"
              placeholder="请输入验证码"
              @blur="checkEvtIdCard"
            />
          </div>
          <div class="err-msg">{{ errMsgIdCard }}</div>
        </div>
      </div>
      <div class="footer">
        <div class="tips">账号绑定后，便可以收到学校发送的消息</div>

        <div class="btn" @click="onSubmit">账号绑定</div>
        <div></div>
      </div>
    </div>
    <div else class="Loading">正在加载中.....</div>
  </div>
</template>
<script>
import { mobileValide, idCardValide } from "@/utils/valide.js";
// import { ref } from "vue"
import { ref, onMounted } from "vue";
import axios from "axios";
import { useStore } from "vuex";
import { Toast } from "vant";
// import moment from "moment";s

export default {
  name: "LoginContent",
  props: {
    schoolName: {
      type: String,
      default: ""
    },
    userName: {
      type: String,
      default: ""
    }
  },
  setup(props) {
    const bottomnumber = ref("180");
    const store = useStore();
    const wxCode = ref("");
    const locationUrl = ref("");
    const myopenid = ref("");
    const schoolCodes = ref([]);
    const bind = ref(false);
    const isopenid = ref(false);
    const getCode = () => {
      //  var appid = "wx8365222892e09e2e"; //个人公众号appid(),在微信公众平台获取
      // 这里用的静默授权
      const code = getUrlParam("code"); // 截取路径中的code，如果没有就去微信授权，如果已经获取到了就直接传code给后台获取openId
      //  const local = window.location.href
      if (code == null || code === "") {
        //url中没有code,重定向到微信接口获取code，此时code在url中
        window.location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx7553914a8c1dbac2&redirect_uri=https%3A%2F%2Fdev.jyrj360.com%2Fweb%2FvisitorH5%2F%23%2Fofficial&response_type=code&scope=snsapi_userinfo&state=state#wechat_redirect";
        locationUrl.value = window.location.search;
      } else {
        wxCode.value = code;
        getOpenId(code); //把code传给后台获取用户信息
      }
    };

    const getOpenId = code => {
      axios({
        method: "GET",
        url: `/sns/oauth2/access_token
?appid=wx7553914a8c1dbac2
&secret=fb52233067958a0986c0fbfb5a0657a0
&code=${code}
&grant_type=authorization_code`
      }).then(res => {
        console.log("-----", res);
        myopenid.value = res.data.openid;
          getFilterList();
        
      });
    };
    const messageModuleList = params =>
      store.dispatch("official/wechatsubscribe", params);
    // 绑定或者解绑公众号用户
    const subscribeopenidphone = params =>
      store.dispatch("official/subscribeopenidphone", params);
    // 手机验证码
    const commonsmscaptcha = params =>
      store.dispatch("official/commonsmscaptcha", params);
    const getPhone = async () => {
      let r = await commonsmscaptcha({
        phone: phone.value,
        smsKey: "717D62F77DF06B87B8B390AFC925ED01"
      });
      if (r.message === "success") {
        console.log(r);
      }
    };
    const getFilterList = async () => {
      let r = await messageModuleList({
        mpAppId: "wx7553914a8c1dbac2",
        // openid: "odSvG4q-QOO1csvtUozREYWPDlas",
        openid: myopenid.value
      });
      if (r.message === "success") {
        bind.value = r.data.bind;
        schoolCodes.value = r.data.schoolCodes;
        if (bind.value==true) {
          window.location.href =
            "https://wxaurl.cn/ZLzuQyMwXTe?schoolCode=${schoolCodes.value}";
        }else{
        isopenid.value=true
        }
      }
    };
    // 绑定公众号用户
    const getUser = async () => {
      let r = await subscribeopenidphone({
        mpAppId: "wx7553914a8c1dbac2",
        openid: myopenid.value,
        event: "subscribe",
        phone: phone.value,
        smsCaptcha: idCard.value
      });
      if (r.message === "success") {
        Toast.success("绑定成功");
      }
    };

    const getUrlParam = name => {
      // 获取url指定参数
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); // 构造一个含有目标的正则表达式对象
      var r = window.location.search.substr(1).match(reg); // 匹配目标参数
      if (r != null) return unescape(r[2]);
      return null; // 返回参数值
    };
    onMounted(() => {
      getCode();
    });

    //   用户姓名
    const userNameLocal = ref(props.userName);
    const errMsgUserNameLocal = ref("");
    const checkEvtUserName = () => {
      if (userNameLocal.value) {
        errMsgUserNameLocal.value = "";
      } else {
        errMsgUserNameLocal.value = "姓名不能为空！";
      }
    };
    // 手机号
    const phone = ref("");
    const errMsgPhone = ref("");
    const checkEvtPhone = () => {
      if (phone.value) {
        if (mobileValide(phone.value)) {
          errMsgPhone.value = "";
        } else {
          errMsgPhone.value = "手机号格式错误！";
        }
      } else {
        errMsgPhone.value = "手机号不能为空！";
      }
    };

    // 身份证号
    const idCard = ref("");
    const errMsgIdCard = ref("");
    const checkEvtIdCard = () => {
      if (idCard.value) {
        if (idCardValide(idCard.value)) {
          errMsgIdCard.value = "";
        }
      } else {
        errMsgIdCard.value = "验证码不能为空！";
      }
    };
    const phoneCode = ref("");
    //获取验证码
    const verificationClick = () => {
      if (phone.value) {
        if (mobileValide(phone.value)) {
          errMsgPhone.value = "";
        } else {
          errMsgPhone.value = "手机号格式错误！";
          return;
        }
      }
      phoneCode.value = 1;
      setInterval(() => {
        bottomnumber.value = bottomnumber.value - 1;
      }, 1000);
      getPhone();
    };
    const open = () => {
      window.location.href = "https://wxaurl.cn/ZLzuQyMwXTe?schoolCode=123456";
    };
    // 提交
    const onSubmit = () => {
      if (!phone.value) {
        errMsgPhone.value = "手机号不能为空！";
        return;
      } else {
        errMsgPhone.value = "";
      }
      if (errMsgPhone.value) {
        errMsgPhone.value = "";
        return;
      }

      if (!idCard.value) {
        errMsgIdCard.value = "验证码不能为空！";
        return;
      } else {
        errMsgIdCard.value = "";
      }
      if (errMsgIdCard.value) {
        return;
      }
      getUser();

      // let params = {
      //   userName: userNameLocal.value,
      //   idNumber: idCard.value,
      //   phone: phone.value,
      // }
      // emit("login", params)
    };

    return {
      userNameLocal,
      checkEvtUserName,
      errMsgUserNameLocal,
      phone,
      errMsgPhone,
      checkEvtPhone,
      idCard,
      errMsgIdCard,
      checkEvtIdCard,
      onSubmit,
      verificationClick,
      getCode,
      getUrlParam,
      getOpenId,
      wxCode,
      locationUrl,
      myopenid,
      schoolCodes,
      bind,
      open,
      phoneCode,
      isopenid,
      bottomnumber
    };
  }
};
</script>

<style lang="less" scoped>
.Loading{
  margin-top:150px;
  text-align:center;
  font-size:26px;
}
.login-content {
  width: 100%;
  height: calc(100vh - 164px);
  background-color: #fff;
  border-radius: 16px 16px 0px 0px;
  .title {
    color: #333333;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    margin: 24px auto;
  }
  .footer {
    margin-top: 64px;
    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 345px;
      height: 36px;
      color: #fff;
      font-size: 15px;
      font-weight: 400;
      background-color: #4174fd;
      border-radius: 36px;
      margin: 0 auto;
    }
    .tips {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 345px;
      height: 36px;
      color: #3333;
      font-size: 15px;
      font-weight: 400;
      margin: 0 auto;
    }
  }
}

.form {
  width: 345px;
  margin: 0 auto;
  .form-item {
    position: relative;
    margin: 24px auto;
    .form-item-field {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      width: 100%;
      height: 36px;
      background: #f2f4fa;
      border-radius: 27px;
      padding: 0 16px;
      label {
        width: 54px;
        color: #999;
      }
      input {
        display: flex;
        align-items: center;
        height: 36px;
        color: #999;
        outline: none;
        border: none;
        background: transparent;
        &::-webkit-input-placeholder {
          color: #ccc;
        }
      }
    }
    .err-msg {
      position: absolute;
      top: 36px;
      left: 70px;
      color: #fe4f54;
      font-size: 14px;
    }
  }
}
.verification {
  color: #3333;
  text-align: right;
}
</style>
